import { Module } from 'vuex'
import { RootState } from '../types'
import { state } from './state'
import { mutations } from './mutations'
import { actions } from './actions'
import { PatientState } from './types'
import { getters } from './getters'

export const patients: Module<PatientState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
